import(/* webpackMode: "eager" */ "/Users/dz151/Documents/telia/lt-telia-web-apps/apps/EShop/app/(root)/(productPages)/prekes/[[...pathParams]]/error.tsx");
